import React, { Component } from "react";
import { withRouter , Link} from "react-router-dom";
import { connect } from 'react-redux';
import { exibeMensagemErro, limpaMensagem, saveState, deleteState } from "../../providers/actions";
import { mostraAguardando, escondeAguardando } from "../../providers/actions";
import { Message } from "../Message/Message";
import { Loading } from "../Loading/Loading";
import { Pagination } from "../Pagination/Pagination";
import { ButtonBack } from "../Button/Back";
import SelectSearch from "../UI/SelectSearch/SelectSearch"
import api from "../../services/api";
import { formataData } from "../../utils/formatadorData";
import './ChavesAPI.css';

const mapDispatchToProps = { saveState, deleteState, exibeMensagemErro, limpaMensagem, mostraAguardando, escondeAguardando }

const mapStateToProps = (state) => {
	return {
		user: state.usuarioStore.user,
		filters: state.filterStore,
	}
}

export const AccessKeysList =

withRouter(

// redux
connect(
	(mapStateToProps), 
	(mapDispatchToProps)
)(

	class extends Component {

		constructor(props){
			super(props);
			this.initialState = {
				orgaos: [],
				orgao: '',
				ativos: '',
				resultadoPesquisa: {},
				pesquisaExecutada : false,
				carregandoOrgaos: false
			};

			this.state = this.initialState;
			this.handleInputChange = this.handleInputChange.bind(this);
			this.handleOrgaoChange = this.handleOrgaoChange.bind(this);
			this.pesquisar = this.pesquisar.bind(this);
			this.executaPesquisaPaginada = this.executaPesquisaPaginada.bind(this);
			this.limparPesquisa = this.limparPesquisa.bind(this);
		}

		render() {
			return (
				<main id="content" className="page-content p-3">
					<Message />
					<Loading />
					<div style={{margin: "10px"}}>
						<h1>Chaves do Órgão</h1>
					</div>
					<div className="div-form1">
						{this.renderForm()}
					</div>
				</main>
			);
		}

		componentDidMount(){
			this.props.limpaMensagem();

			if (this.props.user.isAdministrador) {
				this.setState({carregandoOrgaos : true});
				api.get('/api/orgao/perfil-usuario')
				.then(response => { this.setState({
						orgaos: response.data,
						carregandoOrgaos: false
					}) 
				})
				.catch(erro => {
					this.setState({carregandoOrgaos : false});
					console.log("Não foi possível recuperar órgãos " + erro)
					this.props.exibeMensagemErro("Erro durante o carregamento da página")
				});
			} else {
				this.setState({
					orgao: this.props.user.idOrgao
				})
			}

			if (!this.props.location.state?.resetSearch) {
				this.executarPesquisaAnterior();
			}
		}

		renderForm() {
			const { resultadoPesquisa, pesquisaExecutada } = this.state;
			const { content } = resultadoPesquisa;
			const usuario = this.props.user;

			return(
				<div className="container-fluid">

					<div className="br-form">
						<div className="row">
							<div className="col-md-6">
								<div className="field">
									<div className="input">
										<label htmlFor='orgao'>Órgão:</label>
										{ usuario.isAdministrador && 
											<>
											{this.state.carregandoOrgaos === false &&
												<SelectSearch
													id="orgao"
													name="orgao"
													options={this.state.orgaos.map(orgao => ({ value: orgao.id, label: orgao.nome }))}
													onChange={this.handleOrgaoChange}
													value={this.state.orgao}
												/>
											}
											{this.state.carregandoOrgaos === true && 
												<button className="br-button is-secondary is-circle is-loading" type="button"/>
											}
											</>
										}
										
										{ usuario.isCliente && 
											<input id="orgao"
													name="orgao" type="text" value={usuario.nomeOrgao} readOnly disabled/>
										}
									</div>
								</div>
							</div>
						</div>

						<div className="row">
							<div className="col-sm-2">
								<div className="field">
									<div className="input">
										<label htmlFor="situacao">Situação:</label>
										<SelectSearch
											id="ativos"
											name="ativos"
											options={[{ value: true, label: 'Ativas' }, { value: false, label: 'Inativas' }]}
											includeAllOption={true}
											onChange={this.handleInputChange}
											value={this.state.ativos}
										/>
									</div>
								</div>
							</div>
						</div>

						<div className="actions-button">
							<div className="actions justify-content-start">
								<button type="button" className="button is-primary" onClick={this.pesquisar}>Pesquisar</button>
								<button type="button" className="button is-secondary" onClick={() => this.limparPesquisa()}>Limpar</button>
								<ButtonBack />
							</div>
						</div>

						{(content && content.length > 0) &&	
							<div className="br-table">						
								<div className="table">
									<table>
										<thead>
											<tr>
											<th scope="col">API</th>
											<th scope="col">Chave (ClientID)</th>
											<th scope="col">Responsável pela Chave</th>
											<th scope="col">Aplicação</th>
											<th scope="col">Data de Criação</th>
											<th scope="col">Situação</th>
											<th className="text-center" scope="col">Bloqueada <br/>(Limite de consumo atingido)</th>
											<th className="text-center" scope="col">Ações</th>
											</tr>
										</thead>
										
										<tbody>
											{ content.map((chave, index) =>
													<tr key={index} >
														<td>{chave.nomeApi}</td>
														<td>{chave.clientId}</td>
														<td>{chave.responsavel}</td>
														<td>{chave.aplicacao}</td>
												<td>{formataData(new Date(chave.dataCriacao))}</td>
												<td>{chave.situacao ? 'Ativa' : 'Inativa'}</td>
												<td className="text-center">{chave.limiteConsumoUltrapassado ? 'Sim' : 'Não'}</td>
														<td className="text-center">
															<div className="actions">
															{ (usuario.isCliente === true && chave.limiteConsumoUltrapassado && chave.apiPermiteAdesao) && 
																<Link to={`/solicitacao-adesao/new`}>
																	<button type="button" title="Solicitar Aumento de Volumetria">
																		<span className="sr-only">Solicitar Aumento de Volumetria</span>
																		<i className="fas fa-handshake"></i>
																	</button>
																</Link>
																}
															</div>
														</td>


													</tr>
												)}
										</tbody>
									</table>
									<Pagination totalPaginas={resultadoPesquisa.totalPages} paginaAtual={resultadoPesquisa.number} onChangePage={(pagina, e) => {
										window.scrollTo({ top: 0, behavior: 'smooth' });
										this.executaPesquisaPaginada(pagina, e);
									}}/>
								</div>
							</div>
						}

						{(pesquisaExecutada && (! content || content.length === 0)) &&
							<div>
								Nenhuma credencial encontrada com os critérios informados.
							</div>
						}

					</div>
				</div>

				
			);
		}

		handleInputChange(evento){
			const target = evento.target;
			const nome = target.name;
			const valor = target.type === 'checkbox' ? target.checked : target.value;
			this.setState({[nome]: valor});
		}

		handleOrgaoChange(evento){
			const idOrgao =  evento.target.value;
			this.setState({
				orgao: idOrgao,
			});
		}

		executarPesquisaAnterior() {
			const lastState = this.props.filters[this.props.location.pathname];
			const orgaoCliente = this.props.user.isCliente ? this.props.user.idOrgao : undefined;

			this.setState({
				...this.initialState,
				...lastState,
				...(orgaoCliente !== undefined && { orgao: orgaoCliente }),
				pesquisaExecutada: false,
				resultadoPesquisa: {}
			}, () => {
				if (lastState) {
					const lastPage = lastState ? lastState?.resultadoPesquisa?.number : 0;
					this.executaPesquisaPaginada(lastPage);
				}
			});
		}

		pesquisar (e){
			this.props.limpaMensagem();
			this.executaPesquisaPaginada(0, e);
			if (this.props.location.state?.resetSearch) {
				this.props.history.replace(this.props.location.pathname, {
					...this.props.location.state,
					resetSearch: false,
				  });
			}
		}

		executaPesquisaPaginada(pagina, e){

			try{
				this.validaFormulario();
			}catch(erroValidacao){
				e.preventDefault();
				return;
			}

			const {orgao, ativos} = this.state;
			const criterioPesquisa = {orgao, ativos, pagina};
			const url = '/api/chave-acesso-api/paginado';

			const options = {
				method: 'post',
				url,
				data: criterioPesquisa
			}

			this.props.mostraAguardando()
			api(options)
				.then(response => { 
					this.setState({
						resultadoPesquisa: response.data,
						pesquisaExecutada : true,
					}, () => {
						this.props.saveState(this.state, this.props.location.pathname);
					}) 
				})
				.catch(erro => {
					console.log("Não foi possível recuperar as credenciais do órgão. " + erro)
					this.props.exibeMensagemErro("Erro durante a execução da pesquisa")
				})
				.then( () => {
					this.props.escondeAguardando();
				});
		}

		validaFormulario(){
			let mensagens = [];
			const orgao = this.state.orgao;

			if(orgao === '' || orgao === undefined || orgao === null ){
				mensagens.push({mensagem: "Órgão obrigatório."})
			}

			if(mensagens.length > 0){
				this.props.exibeMensagemErro("Não foi possível realizar a operação porque há inconsistências nos campos informados:", mensagens)
				throw new Error("Formulário não preenchido corretamente.");
			}
		}

		limparPesquisa(){
			this.props.limpaMensagem();
			this.setState({
				orgao: this.props.user.isCliente ? this.props.user.idOrgao : '',
				ativos: '',
				resultadoPesquisa: {},
				pesquisaExecutada : false,
			}, () => {
				this.props.deleteState(this.state, this.props.location.pathname);
			});
		}
	}

) // redux
); // router